import React, { useRef, useState } from "react";
import "../Styles/requestcallback.css";
import { country_data } from "../utils/countryCodes";
import { IMAGES } from "../utils/images";
import axios from "axios";

const RequestCallback = ({onClose}) => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';
  
  console.log('Using API URL:', API_URL);
  
  const modalRef=useRef()
  const [countryEmoji, setCountryEmoji] = useState("🇮🇳");
  const [countryCode, setcountryCode] = useState("+91");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: "",
    message: "Callback request",
    agreedToPrivacyPolicy: true
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      const formattedData = {
        ...formData,
        mobile: `${countryCode} ${formData.mobile}`
      };
      
      console.log('Submitting data to API:', `${API_URL}/api/contact`, formattedData);
      
      const response = await axios.post(`${API_URL}/api/contact`, formattedData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      });
    
      setSuccess(true);
      setFormData({
        name: "",
        email: "",
        mobile: "",
        course: "",
        message: "Callback request",
        agreedToPrivacyPolicy: true
      });
            setTimeout(() => {
        onClose(false);
      }, 2000);
      
    } catch (err) {
      console.error('Error submitting callback request:', err);
      setError(err.response?.data?.error || 'Failed to submit request. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const closeModal=(e)=>{
    if (modalRef.current === e.target){
      onClose(false)
    }
  }

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="outlet-request" ref={modalRef} onClick={closeModal}>
      <div className="request-main">
        <div className="request-top">
          <h1 className="request-heading">Request for Callback</h1>
          <img src={IMAGES.CLOSE_ICON} onClick={()=>onClose(false)}/>
        </div>

        <form onSubmit={handleSubmit} className="form">
          {/* <label id="input-label">Enter Your Name *</label> */}
          <input
            id="input"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Your Name *"
            onClick={stopPropagation}
            required
          />

          {/* <label id="input-label">Email *</label> */}
          <input
            id="input"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Your Email *"
            onClick={stopPropagation}
            required
          />

          {/* <label id="input-label">Mobile Number *</label> */}
          <div className="phonenumber-field">
            <div className="country-container">
              <span className="country-text">{countryEmoji}</span>
              <select
                className="country-dropdown"
                name="country-selector"
                onChange={(e) => {
                  try {
                    const selectedOption = JSON.parse(e.target.value);
                    setCountryEmoji(selectedOption.flag);
                    setcountryCode(selectedOption.code);
                  } catch (err) {
                    console.error('Error parsing country option:', err);
                  }
                }}
              >
                <option value={JSON.stringify({"flag":"🇮🇳","code":"+91"})}>{countryCode}</option>
                {country_data.map((item) => (
                  <option key={item.dial_code} value={JSON.stringify({"flag":item.flag,"code":item.dial_code})}>{item.dial_code}</option>
                ))}
              </select>
            </div>
            <input
              id="input-phone"
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter Your mobile number *"
              onClick={stopPropagation}
              required
            />
          </div>

          {/* <label id="input-label">Course</label> */}
          <input
            id="input"
            type="text"
            name="course"
            value={formData.course}
            onChange={handleChange}
            placeholder="Search for a Course"
            onClick={stopPropagation}
            required
          />

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">Request submitted successfully! We'll contact you soon.</div>}
          
          <button
            type="submit"
            onClick={(e) => e.stopPropagation()}
            className="request-submit-btn"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RequestCallback;
